import React, { Component } from "react";
import { Form, Spinner } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { BaseUrl, Authorization, LogoutFunction } from "../static.js";

const passRegex = new RegExp("^((?=.*[a-z])|(?=.*[A-Z]))(?=.*[0-9])");

export default class SetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordErrorText: "",
      repasswordErrorText: "",
      passwordValue: "",
      repasswordValue: "",
      buttonText: true,
      buttonSpinner: false,
      buttonDisabled: false,
      actionError: "",
    };

    this.passwordHandleChange = this.passwordHandleChange.bind(this);
    this.repasswordHandleChange = this.repasswordHandleChange.bind(this);
    this.onConfirm = this.onConfirm.bind(this);

    this.passwordInput = React.createRef();
  }

  componentDidMount() {
    this.props.onSubmitMobile();
    this.passwordInput.current.focus();
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onConfirm();
    }
  }

  passwordHandleChange(event) {
    this.setState({ passwordValue: event.target.value });
  }

  repasswordHandleChange(event) {
    this.setState({ repasswordValue: event.target.value });
  }

  onForgetPassword() {
    this.props.onForgetPassword();
  }

  onConfirm() {
    this.setState({ actionError: "" });

    if (this.state.passwordValue === "") {
      this.setState({ passwordErrorText: "کلمه عبور را وارد کنید" });
      return;
    } else {
      this.setState({ passwordErrorText: "" });
    }

    if (this.state.passwordValue.length >= 8) {
      this.setState({ passwordErrorText: "" });
    } else {
      this.setState({
        passwordErrorText: "کلمه عبور باید حداقل 8 کاراکتر باشد",
      });
      return;
    }

    if (passRegex.test(this.state.passwordValue)) {
      this.setState({ passwordErrorText: "" });
    } else {
      this.setState({
        passwordErrorText: "کلمه عبور باید ترکیبی از حروف انگلیسی و اعداد باشد",
      });
      return;
    }

    if (this.state.repasswordValue === "") {
      this.setState({ repasswordErrorText: "کلمه عبور را تکرار کنید" });
      return;
    } else {
      this.setState({ repasswordErrorText: "" });
    }

    if (this.state.passwordValue === this.state.repasswordValue) {
      this.setState({ repasswordErrorText: "" });
    } else {
      this.setState({ repasswordErrorText: "کلمات عبور با هم متفاوت است" });
      return;
    }

    this.setState({
      buttonText: false,
      buttonSpinner: true,
      buttonDisabled: true,
    });

    let data = {
      mobile: sessionStorage.getItem("mobile"),
      password: this.state.repasswordValue,
      token: sessionStorage.getItem("token"),
    };

    let apitype = "";
    if (sessionStorage.getItem("userStatus") === "signup") {
      apitype = "signup";
    } else {
      apitype = "setForgetPassword";
    }

    fetch(BaseUrl + "" + apitype, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 201 || result.status === 200) {
          this.LoginUser();
        } else if (result.status === 401) {
          this.props.history.push("/");
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError:
              "اتصال با سرور با مشکل مواجه شد. از اتصال دستگاه به اینترنت اطمینان حاصل فرمائید.",
          });
        }
      });
  }

  LoginUser() {
    let data = {
      mobile: sessionStorage.getItem("mobile"),
      password: this.state.repasswordValue,
    };

    fetch(BaseUrl + "login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          localStorage.setItem("token", result.token);
          localStorage.setItem("mobile", sessionStorage.getItem("mobile"));
          sessionStorage.clear();
          this.props.history.push("/Restaurants");
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError:
              "اتصال با سرور با مشکل مواجه شد. از اتصال دستگاه به اینترنت اطمینان حاصل فرمائید.",
          });
        }
      });
  }

  render() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      return (
        <div className="PasswordPage">
          <div className="inputHeader">
            {/* <div>Mobile Number:&nbsp;{sessionStorage.getItem("mobile")}</div>
                    <div><div onClick={this.state.buttonDisabled ? (event) => event.preventDefault(): this.onForgetPassword.bind(this)} className="linkStyle" style={{fontSize:'12px',margin:'0',fontFamily:'SFUIDisplay'}} >Forget your password?</div></div> */}
          </div>
          <Form.Control
            className={
              this.state.passwordErrorText !== ""
                ? "inputStyle inputStyleError"
                : "inputStyle"
            }
            style={{ direction: "ltr" }}
            placeholder="کلمه عبور جدید را وارد کنید"
            type="password"
            name="password"
            id="password"
            autocomplete="new-password"
            onChange={this.passwordHandleChange}
            value={this.state.passwordValue}
            disabled={this.state.buttonDisabled}
            onKeyPress={this.handleKeyPress.bind(this)}
            ref={this.passwordInput}
          />

          <div
            className="errorMessageContainer"
            style={{ marginBottom: "5px" }}
          >
            {this.state.passwordErrorText}
          </div>

          <Form.Control
            className={
              this.state.repasswordErrorText !== ""
                ? "inputStyle inputStyleError"
                : "inputStyle"
            }
            style={{ direction: "ltr" }}
            placeholder="کلمه عبور جدید را تکرار کنید"
            type="password"
            name="repassword"
            id="repassword"
            onChange={this.repasswordHandleChange}
            value={this.state.repasswordValue}
            disabled={this.state.buttonDisabled}
            onKeyPress={this.handleKeyPress.bind(this)}
          />

          <div className="errorMessageContainer">
            {this.state.repasswordErrorText}
          </div>

          {!this.state.buttonDisabled && (
            <div
              onClick={
                this.state.buttonDisabled
                  ? (event) => event.preventDefault()
                  : this.onConfirm
              }
              className="linkStyle"
            >
              تایید و ورود
            </div>
          )}
          {this.state.buttonDisabled && (
            <Spinner
              style={{
                color: "var(--brown)",
                height: "20px",
                width: "20px",
                marginTop: "20px",
              }}
              animation="border"
            />
          )}
        </div>
      );
    } else {
      return <Redirect to="/Login" />;
    }
  }
}
